import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LocationInterface } from 'types';

export type PackagesPromoShopStore = {
  isRedirectWithoutModal: boolean;
  location: LocationInterface | null;
  step: number;
  promoId: number | null;
};

const initialState: PackagesPromoShopStore = {
  location: null,
  isRedirectWithoutModal: false,
  step: 0,
  promoId: null
};

export const packagesPromoShopSlice = createSlice({
  name: 'packagesPromoShop',
  initialState,
  reducers: {
    setStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    setPromoId: (state, action: PayloadAction<number>) => {
      state.promoId = action.payload;
    },
    resetForm: () => initialState
  }
});

export const { setStep, resetForm, setPromoId } =
  packagesPromoShopSlice.actions;

export default packagesPromoShopSlice.reducer;
